export default (state = { __html: '' }, action) => {
  switch (action.type) {
    case 'VALIDATION_LOGS':
      return action.payload;
    default:
      return state;
  }
};
